import { render, staticRenderFns } from "./auth-base-signup-success.vue?vue&type=template&id=8d4992b0&scoped=true&"
import script from "./auth-base-signup-success.vue?vue&type=script&lang=ts&"
export * from "./auth-base-signup-success.vue?vue&type=script&lang=ts&"
import style0 from "./auth-base-signup-success.vue?vue&type=style&index=0&id=8d4992b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4992b0",
  null
  
)

export default component.exports